import { create } from "../../../../../common/utils/zustand_state_manager";
import { EmpreendimentoDropDown } from "../../../domain/models/empreendimento";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";
import { IncorporacaoBlocoDropDown } from "../../../domain/models/incorporacao_bloco_dropdown";

/**
 * useObrasGestaoServicosFilter
 */

type State = {
  empreendimentosDropDown: EmpreendimentoDropDown[] | null;
  incorporacaoBlocosDropDown: IncorporacaoBlocoDropDown[] | null;
  centroCustosDropDown: CentroCustoDropDown[] | null;
};

export const useObrasGestaoServicosFilter = create<State>((set) => ({
  empreendimentosDropDown: null,
  incorporacaoBlocosDropDown: null,
  centroCustosDropDown: null,
}));